module.exports = __webpack_public_path__ + "img/5-3.3cf8c31a.svg";